import api from './api';

export const searchUserByEmail = async (data) => {
  const response = await api.post(`/user/search`, data);
  return response.data;
};
